import fb from "@bd-core/firebase";
import CONFIG from "./config";

export const updateAttributes = (data) => {
    return fb.update(`${fb.teamAttributesPath}`, data);
};

export const updatePlayerPageId = (pageId) => {
    return fb.update(`${fb.currentPlayerPath}`, {
        currentPageId: pageId,
    });
};

export const updateProfileFirebase = (data) => {
    return fb.update(fb.currentPlayerPath, data);
};

export const setGameStartedAt = async () => {
    let isStarted = null;
    await fb.get(`${fb.teamAttributesPath}/startedAt`).then((snapshot) => {
        isStarted = snapshot.val();
    }).catch((error) => {
        console.error(error);
    });

    if (isStarted) return;

    const sessionTimer = CONFIG?.game?.timeLimit || 0;
    const startedAt = Math.floor(Date.now() / 1000); 
    const shouldFinishAt = startedAt + sessionTimer * 60;

    return fb.update(`${fb.teamAttributesPath}`, {
        startedAt,
        shouldFinishAt,
    });
};

export const setGameFinishedAt = async () => {
    let isFinished = null;
    await fb.get(`${fb.teamAttributesPath}/finishedAt`).then((snapshot) => {
        isFinished = snapshot.val();
    }).catch((error) => {
        console.error(error);
    });

    if (isFinished) return;

    const finishedAt = Math.floor(Date.now() / 1000);

    return fb.update(`${fb.teamAttributesPath}`, {finishedAt});
};

export const setRoundChanges = async (roundID, timer) => {
    const currentPage = window.location.pathname;
    if(currentPage === '/phone') return;

    let currentRound = null;
    await fb.get(`${fb.teamAttributesPath}/currentRoundId`).then((snapshot) => {
        currentRound = snapshot.val();
    }).catch((error) => {
        console.error(error);
    });

    if (currentRound === roundID) return;

    const startedAt = Math.floor(Date.now() / 1000); 
    const shouldEndAt = startedAt + Number(timer);

    return fb.update(`${fb.teamAttributesPath}`, {
        currentRoundId: roundID,
        roundStartedAt: startedAt,
        roundShouldEndAt: shouldEndAt,
    });
};

export const resetGame = async () => {
    return fb.update(`${fb.teamAttributesPath}`, {
        currentRoundId: null,
        roundStartedAt: null,
        roundShouldEndAt: null,
    });
};

export const updateRoundStatus = (roundId, status) => {
    const currentPage = window.location.pathname;
    if(currentPage === '/phone') return;

    return fb.update(`${fb.roundsPath}/${roundId}`, {
        // status: 'finished', 'started', 'unstarted'
        status: status, 
    });
}

export const updateRoundEnergyUsage = async (roundId, energyUsage) => {
    
    const newGreenEnergy = energyUsage.find(energy => energy?.energyType === 'green');
    const newFossilEnergy = energyUsage.find(energy => energy?.energyType === 'fossil');

    if(newGreenEnergy) {
        const totalGreenEnergyUsage = Number(newGreenEnergy?.energyAmount);

        fb.update(`${fb.teamEnergyPath}/${roundId}/green/`, {
            energyUsage: totalGreenEnergyUsage
        });
    }

    if(newFossilEnergy) {
        const totalFossilEnergyUsage = Number(newFossilEnergy?.energyAmount);

        fb.update(`${fb.teamEnergyPath}/${roundId}/fossil/`, {
            energyUsage: totalFossilEnergyUsage
        });
    }

    return true;
};

export const updateTeamScore = async (score) => {
    let currentScore = 0;
    await fb.get(`${fb.teamAttributesPath}/score`).then((snapshot) => {
        currentScore = snapshot.val();
    }).catch((error) => {
        console.error(error);
    });

    const totalScore = currentScore + score;

    fb.update(`${fb.teamAttributesPath}`, {
        score: totalScore,
    });

    return totalScore;
};